import type { AppUndo } from "@shared/models/analytics/app"
import type { FindFn } from "@shared/models/analytics/base"
import { createBlankEvent } from "@shared/models/analytics/base"
import type { PreparedAction } from "@shared/actions/action-doc-builder"
import { assign, partial } from "lodash-es"
import type { PatchModel } from "@shared/models/patch"
import type { Narrative } from "@shared/actions/create-narrative"

interface Payload {
  patches: Array<PatchModel>
  originalActionId: string
  originalActionNarrative: Narrative
}

export default function undoAction(payload: Payload): PreparedAction {
  return {
    name: "UNDO_ACTION",
    payload: payload,
    patches: patches(payload),
    undoPatches: null,
    narrative: partial(narrative, payload),
  }
}

function patches(payload: Payload) {
  return payload.patches
}

function narrative(payload: Payload, findFn: FindFn, userId: string): Narrative {
  let context = assign({}, payload.originalActionNarrative.context, {
    originalAction: payload.originalActionNarrative.titleForAnalytics,
  })
  let newEvent: AppUndo = {
    ...createBlankEvent(),
    root_id: null,
    root_type: "app",
    date_plan_scheduled_for: null,

    primary_verb: "use",
    primary_possessive: "owns",

    primary_object_type: "app",
    primary_object_id: "commoncurriculum.com",
    primary_object_specifier: "undo",
    primary_object_id_and_ancestor_ids: ["commoncurriculum.com"],

    adverbial_verb: null,

    adverbial_object_type: null,
    adverbial_object_id: null,
    adverbial_object_specifier: null,
    adverbial_object_id_and_ancestor_ids: null,
  }

  return {
    title: `Undo ${payload.originalActionNarrative.title}`,
    titleForAnalytics: `Undo Action`,
    description: `Undo ${payload.originalActionNarrative.description}`,
    context,
    activity: payload.originalActionNarrative.activity,
    newAnalyticsEvents: [newEvent],
  }
}
